import { cva, type VariantProps } from 'class-variance-authority'

const l1BadgeVariants = cva(
  '-translate-y-1/2 absolute top-0 right-0 flex h-4 w-4 translate-x-1/2 items-center justify-center rounded border font-bold text-[8px]',
  {
    variants: {
      variant: {
        default: 'border-white/30 bg-black/90',
        primary: 'border-black bg-primary text-black',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

interface L1BadgeProps extends VariantProps<typeof l1BadgeVariants> {}

export function L1Badge({ variant }: L1BadgeProps) {
  return <div className={l1BadgeVariants({ variant })}>L1</div>
}
